'use es6';

import styled from 'styled-components';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';

/* @bend-expect no-styled-foundations-components */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledQuestionPill = styled(Clickable).withConfig({
  displayName: "QuestionPill__StyledQuestionPill",
  componentId: "mhys4r-0"
})(["border-radius:", ";padding:", ";background-color:", ";border:", ";transition:0.3s;:hover{background-color:", ";}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => `${theme.space['100']} ${theme.space['400']}`, ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => `${theme.color['border-tertiary-default']} ${theme.borderWidth['100']} solid`, ({
  theme
}) => theme.color['fill-tertiary-hover']);
const QuestionPill = ({
  id,
  title,
  __description,
  onClick,
  icon: TrellisIcon
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledQuestionPill, {
      onClick: onClick,
      "data-test-id": `${id}-question-pill`,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [TrellisIcon && /*#__PURE__*/_jsx(Flex, {
          marginInlineEnd: "200",
          alignItems: "center",
          children: /*#__PURE__*/_jsx(TrellisIcon, {
            size: "300",
            color: "fill-accent-neutral-default"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-125",
          color: "fill-accent-neutral-default",
          children: title
        })]
      })
    })
  );
};
export default QuestionPill;